import React, { useEffect, useMemo, useState } from "react";
import { Izpalace } from "../Izpalace/Izpalace";
import { IzpalaceCenter } from "../IzpalaceCenter";
import classNames from "classnames";
import { useIztro } from "iztro-hook";
import "../styles/index.css";
import { getPalaceNames } from "iztro/lib/astro";
export const Iztrolabe = (props) => {
    const [taichiPoint, setTaichiPoint] = useState(-1);
    const [taichiPalaces, setTaichiPalaces] = useState();
    const [activeHeavenlyStem, setActiveHeavenlyStem] = useState();
    const [hoverHeavenlyStem, setHoverHeavenlyStem] = useState();
    const [focusedIndex, setFocusedIndex] = useState();
    const [showDecadal, setShowDecadal] = useState(false);
    const [showYearly, setShowYearly] = useState(false);
    const [showMonthly, setShowMonthly] = useState(false);
    const [showDaily, setShowDaily] = useState(false);
    const [showHourly, setShowShowHourly] = useState(false);
    const [horoscopeDate, setHoroscopeDate] = useState();
    const [horoscopeHour, setHoroscopeHour] = useState();
    const { astrolabe, horoscope, setHoroscope } = useIztro({
        birthday: props.birthday,
        birthTime: props.birthTime,
        gender: props.gender,
        birthdayType: props.birthdayType,
        fixLeap: props.fixLeap,
        isLeapMonth: props.isLeapMonth,
        lang: props.lang,
        astroType: props.astroType,
        options: props.options,
    });
    const toggleShowScope = (scope) => {
        switch (scope) {
            case "decadal":
                setShowDecadal(!showDecadal);
                break;
            case "yearly":
                setShowYearly(!showYearly);
                break;
            case "monthly":
                setShowMonthly(!showMonthly);
                break;
            case "daily":
                setShowDaily(!showDaily);
                break;
            case "hourly":
                setShowShowHourly(!showHourly);
                break;
        }
    };
    const toggleActiveHeavenlyStem = (heavenlyStem) => {
        if (heavenlyStem === activeHeavenlyStem) {
            setActiveHeavenlyStem(undefined);
        }
        else {
            setActiveHeavenlyStem(heavenlyStem);
        }
    };
    const dynamic = useMemo(() => {
        if (showHourly) {
            return {
                arrowIndex: horoscope?.hourly.index,
                arrowScope: "hourly",
            };
        }
        if (showDaily) {
            return {
                arrowIndex: horoscope?.daily.index,
                arrowScope: "daily",
            };
        }
        if (showMonthly) {
            return {
                arrowIndex: horoscope?.monthly.index,
                arrowScope: "monthly",
            };
        }
        if (showYearly) {
            return {
                arrowIndex: horoscope?.yearly.index,
                arrowScope: "yearly",
            };
        }
        if (showDecadal) {
            return {
                arrowIndex: horoscope?.decadal.index,
                arrowScope: "decadal",
            };
        }
    }, [showDecadal, showYearly, showMonthly, showDaily, showHourly, horoscope]);
    useEffect(() => {
        setHoroscopeDate(props.horoscopeDate ?? new Date());
        setHoroscopeHour(props.horoscopeHour ?? 0);
    }, [props.horoscopeDate, props.horoscopeHour]);
    useEffect(() => {
        setHoroscope(horoscopeDate ?? new Date(), horoscopeHour);
    }, [horoscopeDate, horoscopeHour]);
    useEffect(() => {
        if (taichiPoint < 0) {
            setTaichiPalaces(undefined);
        }
        else {
            const palaces = getPalaceNames(taichiPoint);
            setTaichiPalaces(palaces);
        }
    }, [taichiPoint]);
    const toggleTaichiPoint = (index) => {
        if (taichiPoint === index) {
            setTaichiPoint(-1);
        }
        else {
            setTaichiPoint(index);
        }
    };
    return (React.createElement("div", { className: classNames("iztro-astrolabe", "iztro-astrolabe-theme-default") },
        astrolabe?.palaces.map((palace) => {
            return (React.createElement(Izpalace, { key: palace.earthlyBranch, focusedIndex: focusedIndex, onFocused: setFocusedIndex, horoscope: horoscope, showDecadalScope: showDecadal, showYearlyScope: showYearly, showMonthlyScope: showMonthly, showDailyScope: showDaily, showHourlyScope: showHourly, taichiPalace: taichiPalaces?.[palace.index], toggleScope: toggleShowScope, activeHeavenlyStem: activeHeavenlyStem, toggleActiveHeavenlyStem: toggleActiveHeavenlyStem, hoverHeavenlyStem: hoverHeavenlyStem, setHoverHeavenlyStem: setHoverHeavenlyStem, toggleTaichiPoint: toggleTaichiPoint, ...palace }));
        }),
        React.createElement(IzpalaceCenter, { astrolabe: astrolabe, horoscope: horoscope, horoscopeDate: horoscopeDate, horoscopeHour: horoscopeHour, setHoroscopeDate: setHoroscopeDate, setHoroscopeHour: setHoroscopeHour, centerPalaceAlign: props.centerPalaceAlign, ...dynamic })));
};
